<div class="size-screen flex flex-col">
    <header
        class="bg-gradient-to-br from-brand-briefcream via-brand-nude/10 to-brand-briefcream border-b border-brand-goldline/20">
        <!-- Main Title Area -->
        <div class="max-w-6xl mx-auto px-4 py-6">
            <div class="flex flex-col md:flex-row items-center justify-between gap-4">

                <!-- Left: Main Titles -->
                <div class="flex flex-col items-center md:items-start">
                    <h1 class="font-[Parisienne] text-4xl text-brand-inktint leading-tight">Tabea & Stephan</h1>
                    <h2 class="font-[Neuton] text-lg text-brand-inktint/80 mt-1 tracking-wide">Wir heiraten!</h2>
                </div>

                <!-- Right: Current Page Context -->
                <div class="text-center md:text-right">
                    <div class="font-[Parisienne] text-2xl text-brand-goldline" [innerHTML]="getPageTitle()"></div>
                    <div class="font-[Neuton] text-sm text-brand-inktint/70 mt-1" [innerHTML]="getPageSubtitle()"></div>
                </div>
            </div>
        </div>

        <!-- Navigation Bar -->
        <div class="bg-white/50 backdrop-blur-sm border-t border-brand-goldline/10">
            <nav class="max-w-6xl mx-auto px-4 py-3">
                <div class="flex flex-row gap-4 justify-center font-[Neuton] flex-wrap text-sm relative z-10">
                    <!-- Clean Navigation - Final Pages Only -->
                    <div class="flex flex-row gap-6 justify-center">
                        @if (auth.hasFullAccess()) {
                        <a [routerLink]="['/details']" routerLinkActive="text-brand-goldline font-semibold"
                            class="hover:text-brand-goldline transition-colors duration-200 px-2 py-1">
                            Hochzeit
                        </a>
                        }

                        @if(auth.hasPolterabendAccess()) {
                        <a [routerLink]="['/polter']" routerLinkActive="text-brand-goldline font-semibold"
                            class="hover:text-brand-goldline transition-colors duration-200 px-2 py-1">
                            Polterabend
                        </a>
                        }


                        <a [routerLink]="['/form']" routerLinkActive="text-brand-goldline font-semibold"
                            class="hover:text-brand-goldline transition-colors duration-200 px-2 py-1">
                            {{ auth.hasFullAccess() ? 'Antwort' : 'Anmeldung' }}
                        </a>

                        <a [routerLink]="['/contact']" routerLinkActive="text-brand-goldline font-semibold"
                            class="hover:text-brand-goldline transition-colors duration-200 px-2 py-1">
                            Kontakt
                        </a>
                    </div>
                </div>
            </nav>
        </div>

        <!-- Logout Button -->
        <div class="text-center py-2 bg-white/30 border-t border-brand-goldline/10">
            <button (click)="logout()"
                class="text-xs text-brand-inktint/60 hover:text-brand-goldline transition-colors duration-200 font-[Neuton]">
                Abmelden
            </button>
        </div>
    </header>

    <div class="flex-1 overflow-auto ">
        <router-outlet />
    </div>
</div>